import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Chip, Divider, Stack, Typography} from 'views/components';
import {MarkdownViewer, Translate, translate} from 'views/module';
import {HoverToolBox} from 'views/module';

import {TASK_TYPES} from './utils/constants';

const TaskView = (props) => {
  const [toolbarVisible, setToolbarVisible] = React.useState(false);
  const [mouseOver, setMouseOver] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const task = props.task;
  const onClickEditTask = props.onClickEditTask;
  const removeTask = props.removeTask;

  const title = task.title;
  const description = task.description.blob;
  const dueDate = task.dueDate;
  const taskType = task.type;
  const mappedTaskTypeConfig = taskType ? TASK_TYPES[taskType] : null;
  const taskTypeConfig = taskType ? (mappedTaskTypeConfig ?? TASK_TYPES.UNKNOWN) : null;
  const taskTypeLabel = mappedTaskTypeConfig?.labelKey ? translate(mappedTaskTypeConfig.labelKey) : taskType;
  const taskComplete = task.status === 'COMPLETE';

  React.useEffect(() => {
    setToolbarVisible(mouseOver);
  }, [mouseOver]);

  return (
    <Box>
      <Divider />
      <Box
        onMouseOver={(e) => setMouseOver(true) & setAnchorEl(e.currentTarget)}
        onMouseLeave={() => setMouseOver(false)}
        sx={{
          backgroundColor: toolbarVisible ? 'background.highlighted' : 'inherit',
          p: 2,
        }}
      >
        <Stack spacing={1} sx={{opacity: taskComplete ? 0.45 : 1}}>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            alignItems={{xs: 'flex-start', sm: 'center'}}
            justifyContent='space-between'
            spacing={1}
            sx={{
              pr: {xs: 0, sm: 5},
            }}
          >
            <Stack direction='row' alignItems='center' spacing={2}>
              {
                taskType &&
                  <Chip
                    label={taskTypeLabel}
                    variant="outlined"
                    size="small"
                    sx={{
                      fontWeight: 600,
                      textTransform: 'uppercase',
                      letterSpacing: '0.04em',
                      borderWidth: 1,
                      ...taskTypeConfig?.chipSx,
                    }}
                  />
              }
              <Stack>
                <Typography
                  variant='subtitle1'
                  sx={{
                    fontWeight: 600,
                    textDecoration: taskComplete ? 'line-through' : 'none',
                  }}
                >
                  {title}
                </Typography>
              </Stack>
            </Stack>
          </Stack>

          <Stack>
            {
              description &&
                <Stack direction='row' spacing={1} alignItems='center'>
                  <Typography
                    variant='subtitle2'
                    sx={{
                      fontWeight: 500,
                    }}
                  >
                    <Translate expression='caregiver.CaregiverDetail.Tasks.TabLabels.Description' />
                  </Typography>
                  <Typography variant='body2' component='div'>
                    <MarkdownViewer value={description} />
                  </Typography>
                </Stack>
            }
            {
              dueDate &&
                <Stack direction='row' spacing={1} alignItems='center'>
                  <Typography
                    variant='subtitle2'
                    sx={{
                      fontWeight: 500,
                    }}
                  >
                    <Translate expression='caregiver.CaregiverDetail.Tasks.TabLabels.DueDate' />
                  </Typography>
                  <Typography variant='body2'>
                    {
                      new Date(dueDate).toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                      })
                    }
                  </Typography>
                </Stack>
            }
          </Stack>
        </Stack>

        <HoverToolBox
          toolBar={toolbarVisible}
          anchorEl={anchorEl}
          onClickEdit={() => onClickEditTask(task)}
          onClickDelete={() => removeTask(task)}
          hideTool={{
            emoji: true,
            copy: true,
            edit: false,
            delete: false,
            reply: true,
          }}
        />
      </Box>
    </Box>
  );
};

TaskView.propTypes = {
  task: PropTypes.object.isRequired,
  onClickEditTask: PropTypes.func,
  removeTask: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(TaskView));
